import { CopyIcon } from "@chakra-ui/icons";
import {
  Box, Button as CButton, CircularProgress, Container,
  Grid,
  Heading,
  HStack,
  IconButton,
  Stack,
  Text,
  useDisclosure,
  VStack
} from "@chakra-ui/react";
import StarBorderIcon from "@material-ui/icons/Star";
import Rating from "@material-ui/lab/Rating";
import { ReactComponent as FileIcon } from "assets/svg/fileIcon.svg";
import Button from "components/Button/Button";
//Components
import Header from "components/dashHeader";
import Messanger from "components/Messager/Messanger";
import ConfirmationModal from "components/Modals/p2p/Confirmation";
import UploadProve from "components/Modals/p2p/UploadProve";
import Sidemenu from "components/sidemenu";
import { format, parseISO } from "date-fns";
import useMinsCountDown from "hooks/useMinsCountDown";
import usePusher from "hooks/usePusher";
import { toLower, toUpper } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  useGetBuyTradeSessionQuery,
  useRateTradeMutation,
  useUpdateTradeSessionMutation
} from "services/p2pApi";
import { useStore } from "store";
import { uploadFile } from "util/do";
import formatter from "util/formatter";
import { floatString } from "util/utils";



const Unpaid = ({ trader, tradeId, frozenRef }) => {
  const [file, setFile] = useState();
  const [isUploading, setIsUploading] = useState(false);

  const { timer: countDown } = useMinsCountDown(
    trader?.timeline?.dueAt,
    `${trader?.timeline?.duration}m : 00s`
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: cancelIsOpen,
    onOpen: cancelOnOpen,
    onClose: cancelOnClose,
  } = useDisclosure();

  const {
    isOpen: uploadProveIsOpen,
    onOpen: onOpenUploadProve,
    onClose: onCloseUploadProve,
  } = useDisclosure();

  const [_updateTradeSession, { isLoading: isUpdating, isSuccess }] =
    useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation, paymentProof = null) =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
        paymentProof,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );

  // console.log(
  //   "TIMER::",
  //   countDown
  //   // `DUE AT :: ${parseISO(trader?.timeline?.dueAt).getTime()}`,
  //   // `CREATED AT :: ${trader?.timeline?.createdAt}`,
  //   // subMinutes(parseISO(trader?.timeline?.dueAt), +trader?.timeline?.duration)
  // );

  const getPaymentOptions = () => {
    let options = [];
    trader?.payTo?.forEach((option) => {
      if (
        toLower(option.label) === "external wallet" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) === "changera"
      ) {
        options.push({ method: "changeraId", ...option });
      }
      if (
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "changera" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "bitmama wallet"
      )
        options.push({ method: "bankTransfer", ...option });
    });

    return options;
  };

  const bankDetail =
    trader &&
    getPaymentOptions().filter((option) => option.method === "bankTransfer")[0];

  // console.log("PAY TO", bankDetail);

  useEffect(() => {
    if (isSuccess) {
      cancelOnClose();
    }
  }, [isSuccess, cancelOnClose]);

  const handlePaid = () => {
    onClose();
    setTimeout(() => onOpenUploadProve(), 100);
  };

  const handleUploadAndConfirmPayment = async () => {
    if (!file) {
      updateSession("CONFIRMPAYMENT");
    } else {
      setIsUploading(true);
      const res = await uploadFile(file);
      updateSession("CONFIRMPAYMENT", res.location);
      console.log("FILE", res);
      setIsUploading(false);
    }
  };

  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Bank Details</Heading>

        <HStack mt="18px" direction="row" gridGap="100px">
          <VStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm" mt="0px !important">
              Name
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="18px !important">
              Bank
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="18px !important">
              Account no.
            </Text>
          </VStack>

          <VStack alignItems="flex-start">
            <HStack mt="0px !important">
              <Text fontSize="sm" mt="0 !important">
                {/* Chioma Adekunle Buhari */}
                {bankDetail?.accountName}
              </Text>
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              />
            </HStack>

            <HStack mt="16px !important">
              <Text fontSize="sm" mt="0 !important">
                {/* Guaranty Trust Bank */}
                {bankDetail?.receivingIntoLabel}
              </Text>
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              />
            </HStack>

            <HStack mt="16px !important" justifyContent="flex-start">
              <Text fontSize="sm">
                {/* 0123456789 */}
                {bankDetail?.receivingIntoAddress}
              </Text>
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              />
            </HStack>
          </VStack>
        </HStack>
      </Box>

      <Stack mt="24px !important">
        <Text fontSize="sm">Time limit</Text>
        <Text fontSize="sm" mt="0 !important" color="#03A438">
          {/* {trader?.timeline?.duration} mins */}
          {countDown}
        </Text>

        <Text mt="32px !important" fontSize="sm" color="#4E4B66">
          Please ensure payment is made within {trader?.timeline?.duration}:00
          mins, else the transaction would be cancelled.
        </Text>
      </Stack>

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        <Button
          // h="56px"
          onClick={cancelOnOpen}
          minW="120px !important"
          // px="10px"
          bg="transparent"
          border="2px solid transparent"
          color="#03A438"
        >
          Cancel trade
        </Button>
        <Button onClick={onOpen} minW="120px !important">
          Paid
        </Button>
      </HStack>

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={handlePaid}
        title="Confirm payment"
      >
        <VStack>
          <Text textAlign="center">
            Please confirm that you have made payment of{" "}
            <strong>
              {formatter(trader?.unitToPay).format(trader?.amountToPay)}
            </strong>{" "}
            to the seller's account.
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>

      <UploadProve
        isOpen={uploadProveIsOpen}
        onClose={onCloseUploadProve}
        isLoading={isUploading || isUpdating}
        onConfirm={handleUploadAndConfirmPayment}
        onFileChange={(file) => setFile(file)}
      />
    </>
  );
};

const Paid = ({ trader, tradeId, frozenRef, setStatus }) => {
  const { timer: countDown, expired } = useMinsCountDown(
    trader?.timeline?.dueAt,
    `${trader?.timeline?.duration}m : 00s`
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: cancelIsOpen,
    onOpen: cancelOnOpen,
    onClose: cancelOnClose,
  } = useDisclosure();

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(trader?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [trader]);

  const [_updateTradeSession, { isLoading: isUpdating }] =
    useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation, reason = "") =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
        reason,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Paid</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            {toUpper(trader?.unitToReceive)} to be released in:
          </Text>
          <Text fontSize="sm" color={expired ? "red.500" : "#03A438"}>
            {/* {trader?.timeline?.duration} mins */}
            {countDown}
          </Text>
        </HStack>
      </Box>

      {trader?.proofOfWaiver && (
          <Stack borderTop="1px solid #D9DBE9" p="32px 0">
              <Stack mb="20px">
                <Text fontSize="sm" mr="10px !important">
                  Proof of Payment
                </Text>

                <CButton
                  w="fit-content"
                  leftIcon={<Box boxSize="16px" as={FileIcon} />}
                  fontSize="xs"
                  variant="link"
                  color="#4878FF"
                  _focus={{ shadow: "0 0 0 3px #06C3448f" }}
                  onClick={() => window.open(trader.proofOfWaiver, "_blank")}
                >
                  {proofOfWaiverFileName}
                </CButton>
              </Stack>
          </Stack>)}

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        <Button
          // h="56px"
          disabled={isUpdating}
          onClick={cancelOnOpen}
          minW="120px !important"
          // px="10px"
          bg="transparent"
          border="2px solid transparent"
          color="#03A438"
        >
          Cancel trade
        </Button>
        <Button
          disabled={isUpdating || !expired}
          isLoading={isUpdating}
          onClick={onOpen}
          minW="120px !important"
        >
          Dispute
        </Button>
      </HStack>

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("DISPUTE", "dispute")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">Are you sure about this?</Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>
    </>
  );
};

const Cancelled = ({ timeout }) => {
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Cancelled</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            You have successfully cancelled the trade, Feel free to initiate a
            new trade
          </Text>
        </HStack>
      </Box>
    </>
  );
};

const Timedout = ({ timeout }) => {
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Timedout</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            Order timedout.
          </Text>
        </HStack>
      </Box>
    </>
  );
};

const Completed = ({ trade, trader, tradeId, frozenRef }) => {
  const history = useHistory();

  const [_rateTrade, { isLoading: isRating }] = useRateTradeMutation();

  const userData = JSON.parse(localStorage.getItem("btm_user"));

  const rate = trade?.ratings?.find(
    (rate) => rate?.userId === userData?.userId
  );

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(trader?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [trader]);

  const rateTrade = useCallback(
    (rating) =>
      tradeId &&
      frozenRef &&
      _rateTrade({
        id: tradeId,
        frozenRef,
        rating,
      }),
    [tradeId, frozenRef, _rateTrade]
  );
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Completed</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
          {toUpper(trade?.coin ?? "Coin")} has been released by the seller to your wallet and order has completed successfully.

          </Text>
        </HStack>
      </Box>

      <Stack p="20px 0" maxW="100px">
        <Button
          onClick={() => history.replace("/dashboard/wallet")}
          bg="transparent"
          minW="80px !important"
          fontSize="xs"
          fontWeight="400"
          color="#03A438"
          p="0 !important"
        >
          View wallet
        </Button>
      </Stack>

      <Stack borderTop="1px solid #D9DBE9" p="32px 0">
          {trader?.proofOfWaiver && (
            <Stack mb="20px">
              <Text fontSize="sm" mr="10px !important">
                Proof of Payment
              </Text>

              <CButton
                w="fit-content"
                leftIcon={<Box boxSize="16px" as={FileIcon} />}
                fontSize="xs"
                variant="link"
                color="#4878FF"
                _focus={{ shadow: "0 0 0 3px #06C3448f" }}
                onClick={() => window.open(trader.proofOfWaiver, "_blank")}
              >
                {proofOfWaiverFileName}
              </CButton>
            </Stack>
          )}
        <Stack>
          {!rate && (
            <Text fontSize="sm" color="#14142B">
              Rate this trade
            </Text>
          )}

          <Rating
            disabled={isRating || rate?.rating}
            value={rate?.rating ?? 0}
            name="order-rating"
            color="yellow"
            // defaultValue={2}
            precision={0.5}
            emptyIcon={
              <Box as={StarBorderIcon} color="#A0A3BD" fontSize="inherit" />
            }
            onChange={(event, newValue) => {
              rateTrade(newValue);
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};

const P2pBuyMakePayment = (props) => {
  const { store } = useStore();

  const [isCompleted, setIsCompleted] = useState(false);
  const [, setStatus] = useState("unpaid");
  const { id } = useParams();
  const { data: _data, isLoading } = useGetBuyTradeSessionQuery(id, {
    pollingInterval: isCompleted ? 0 : 0,
  });
  const [data, setData] = useState(_data);

  const tokenRef = useRef(store.token)

  useEffect(() => {
    if(!isLoading) {
      setData(_data)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  const [chatState, setChatState] = useState({
    chatOpened: false,
    chatInFocus: false,
    unReadChats: [],
  });


  const [tradeId, frozenRef] = (data && String(id).split("-")) ?? [];

  const channelName = `${tradeId}-${frozenRef}`;

  const applyContractUpdate = useCallback((data) => {
    setData(data)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  const watchChats = useCallback((data) => {
    if(data?.username === store?.userData?.username) return;
    if(chatState.chatOpened) {
      if(chatState.chatInFocus) {}
      else {
        setChatState((p) => ({...p, unReadChats: p?.unReadChats.concat(data)}))
      }
    }
    else {
      setChatState((p) => ({...p, unReadChats: p?.unReadChats.concat(data)}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatState?.unReadChats?.length, chatState?.chatOpened])

  const tradeUpdateHandlers = useMemo(() => ({
    "trade-update": {
      register: true,
      do: applyContractUpdate,
    },
    "test-event": {
      register: true,
      do: (d) => {
        console.log({d})
      }
    },
    "chat-update": {
      register: true,
      do: watchChats
    }
  }), [applyContractUpdate, watchChats])

  usePusher({
    accessKey: tokenRef.current,
    channelName,
    handlers: tradeUpdateHandlers,
    endpoint: "p2p/realtime/trade/auth",
    skip: !tokenRef.current
  })

  useEffect(() => {
    if(!isLoading) {
      setData(_data)
    }
  }, [_data, isLoading])


  useEffect(() => {
    if (
      data?.contractState === "closed" ||
      data?.contractState === "timeout" ||
      data?.contractState === "cancelled"
    ) {
      // set to true to disable polling when trade is closed, timedout or cancelled
      setIsCompleted(true);
    }
  }, [data]);

  const getTrader = () =>
    data?.counterParties?.find((cp) => cp.role === "trader");

  const tradeOwner = useMemo(
    () =>
      data?.counterParties?.find(
        (cp) => String(cp.role).toLowerCase() === "tradeowner"
      ),
    [data?.counterParties]
  );
  const trader = useMemo(
    () =>
      data?.counterParties?.find(
        (cp) => String(cp.role).toLowerCase() === "trader"
      ),
    [data?.counterParties]
  );

  const getStatus = () => {
    return `${data?.contractState}&${getTrader()?.obligationStatus}`;
  };

  const mapStatusToComponent = (status) => {
    const map = {
      "open&pending": (
        <Unpaid trader={getTrader()} tradeId={tradeId} frozenRef={frozenRef} />
      ),
      "open&fulfilled": (
        <Paid
          trader={getTrader()}
          tradeId={tradeId}
          frozenRef={frozenRef}
          setStatus={setStatus}
        />
      ),
      "closed&fulfilled": (
        <Completed
          trade={data}
          trader={getTrader()}
          setStatus={setStatus}
          tradeId={tradeId}
          frozenRef={frozenRef}
        />
      ),
      "cancelled&pending": (
        <Cancelled timeout={data && getTrader()?.timeline?.duration} />
      ),
      "cancelled&fulfilled": (
        <Cancelled timeout={data && getTrader()?.timeline?.duration} />
      ),
      "timeout&pending": (
        <Cancelled timeout={data && getTrader()?.timeline?.duration} />
      ),
      "timeout&fulfilled": (
        <Timedout timeout={data && getTrader()?.timeline?.duration} />
      ),
    };

    return map[status];
  };

  const isSessionActive = () =>
    getStatus() &&
    getStatus() !== "cancelled&pending" &&
    getStatus() !== "closed&fulfilled" &&
    getStatus() !== "timeout&pending";

  return (
    <Box
      __css={{
        "--color": "#4E4B66",
        "--borderColor": "#D9DBE9",
        "--focusColor": "#06c34491",
        "--primary": "#03A438",
      }}
    >
      <Sidemenu currentPage="P2P" logoutUser={props.logout} />
      <Header />

      <Box className="p2p">
        <Box className="p2p-container">
          {isLoading && (
            <CircularProgress isIndeterminate size="20px" color="green" />
          )}

          {!isLoading && (
            <Container maxW="container.xl">
              <Heading fontSize="3xl">Buy {toUpper(data?.coin ?? "")}</Heading>

              <Grid
                templateColumns=".55fr .4fr"
                overflow="hidden"
                mt="48px"
                gridGap="20px"
              >
                <Box bg="white" borderRadius="16px" h="fit-content">
                  <HStack
                    alignItems="flex-start"
                    gridGap="32px"
                    p="20px 32px"
                    borderBottom="1px solid #D9DBE9"
                  >
                    <Stack>
                      <Text color="#4E4B66" fontSize="sm">
                        Date
                      </Text>
                      <Text fontSize="sm" mt="0px !important">
                        {/* 17-06-2021 */}

                        {data && format(parseISO(data?.createdAt), "dd-MM-yyy")}
                      </Text>
                    </Stack>
                    <Stack>
                      <Text color="#4E4B66" fontSize="sm">
                        Time
                      </Text>
                      <Text fontSize="sm" mt="0px !important">
                        {data && format(parseISO(data?.createdAt), "HH:mm")}
                      </Text>
                    </Stack>
                    <Stack>
                      <Text color="#4E4B66" fontSize="sm">
                        ID
                      </Text>
                      <HStack mt="0px !important">
                        <Text fontSize="sm">{data?.id}</Text>
                        <IconButton
                          size="xs"
                          variant="ghost"
                          aria-label="copy"
                          icon={<CopyIcon />}
                        />
                      </HStack>
                    </Stack>
                  </HStack>

                  <Stack p="32px">
                    <HStack
                      alignItems="flex-start"
                      justifyContent="space-between"
                    >
                      <Stack>
                        <Text color="#4E4B66" fontSize="sm">
                          Amount
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="bold"
                          mt="0px !important"
                        >
                          {/* ₦12,000 */}
                          {data &&
                            formatter(data?.currency).format(data?.amount)}{" "}
                        </Text>
                      </Stack>
                      <Stack>
                        <Text color="#4E4B66" fontSize="sm">
                          Quantity
                        </Text>
                        <Text fontSize="sm" mt="0px !important">
                          {floatString(data?.volume)}{" "}
                          {toUpper(data?.coin ?? "")}
                        </Text>
                      </Stack>
                      <Stack>
                        <Text color="#4E4B66" fontSize="sm">
                          Transaction Fee
                        </Text>
                        <Text mt="0px !important" fontSize="sm">
                          {/* 19,190,000.00 */}
                          {floatString(getTrader()?.tradeFee)}{" "}
                          {toUpper(data?.coin ?? "")}
                        </Text>
                      </Stack>
                    </HStack>

                    {mapStatusToComponent(getStatus())}
                  </Stack>
                </Box>

                {tradeId && frozenRef && (
                  <Messanger
                    sessionActive={isSessionActive()}
                    tradeId={tradeId}
                    frozenRef={frozenRef}
                    trader={trader}
                    tradeOwner={tradeOwner}
                    chatState={chatState} 
                    setChatState={setChatState}
                  />
                )}
              </Grid>
            </Container>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default P2pBuyMakePayment;
